module.exports = __webpack_public_path__ + "media/4x3/bf-9a958401.svg";